// Copied from the jody-landing-page repo (src/components/social.tsx); keep
// the two in sync so the app header and the homepage show the same profiles.

import type { SVGProps } from "react";
import { Instagram } from "lucide-react";

// Outline TikTok glyph drawn on lucide's 24px / stroke-2 grid so it sits
// next to lucide's Instagram icon without looking heavier.
export const TikTokIcon = ({ size = 24, ...props }: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917z" />
  </svg>
);

type SocialLink = {
  name: string;
  handle: string;
  url: string;
  Icon: typeof Instagram | typeof TikTokIcon;
};

// Jody's public profiles. An entry with an empty url is not rendered.
const ALL_SOCIAL_LINKS: SocialLink[] = [
  { name: "Instagram", handle: "@travelwithjody", url: "https://www.instagram.com/travelwithjody", Icon: Instagram },
  { name: "TikTok", handle: "", url: "", Icon: TikTokIcon },
];

export const SOCIAL_LINKS = ALL_SOCIAL_LINKS.filter((link) => link.url);
